import Modal, { ModalProps } from "@/Components/Modal/Modal";
import { useModalMeta } from "@/shared/atoms/useModal";
import useCommon from "@/shared/hooks/useCommon";
import { RestaurantTable } from "@/shared/utils/interfaces";

export interface TableModalProps extends ModalProps {}

const TableOrdersModal = ({ onExit, ...props }: TableModalProps) => {
  const [meta] = useModalMeta();
  const { table } = meta as { table: RestaurantTable };
  const tCommon = useCommon();

  return (
    <Modal width={"50rem"} onExit={onExit} {...props}>
      <div className="flex items-center">
        <h2>{tCommon("overviewOfOrdersOfTable")}</h2>
      </div>
    </Modal>
  );
};

export default TableOrdersModal;
